/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PermissionVmPaginatedSearchResponse,
    PermissionVmPaginatedSearchResponseFromJSON,
    PermissionVmPaginatedSearchResponseFromJSONTyped,
    PermissionVmPaginatedSearchResponseToJSON,
    RoleListVm,
    RoleListVmFromJSON,
    RoleListVmFromJSONTyped,
    RoleListVmToJSON,
    RolePermissionDto,
    RolePermissionDtoFromJSON,
    RolePermissionDtoFromJSONTyped,
    RolePermissionDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface RolePermissionRelationsVm
 */
export interface RolePermissionRelationsVm {
    /**
     * 
     * @type {PermissionVmPaginatedSearchResponse}
     * @memberof RolePermissionRelationsVm
     */
    permissions?: PermissionVmPaginatedSearchResponse;
    /**
     * 
     * @type {Array<RoleListVm>}
     * @memberof RolePermissionRelationsVm
     */
    roles?: Array<RoleListVm> | null;
    /**
     * 
     * @type {Array<RolePermissionDto>}
     * @memberof RolePermissionRelationsVm
     */
    relations?: Array<RolePermissionDto> | null;
}

export function RolePermissionRelationsVmFromJSON(json: any): RolePermissionRelationsVm {
    return RolePermissionRelationsVmFromJSONTyped(json, false);
}

export function RolePermissionRelationsVmFromJSONTyped(json: any, ignoreDiscriminator: boolean): RolePermissionRelationsVm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'permissions': !exists(json, 'permissions') ? undefined : PermissionVmPaginatedSearchResponseFromJSON(json['permissions']),
        'roles': !exists(json, 'roles') ? undefined : (json['roles'] === null ? null : (json['roles'] as Array<any>).map(RoleListVmFromJSON)),
        'relations': !exists(json, 'relations') ? undefined : (json['relations'] === null ? null : (json['relations'] as Array<any>).map(RolePermissionDtoFromJSON)),
    };
}

export function RolePermissionRelationsVmToJSON(value?: RolePermissionRelationsVm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'permissions': PermissionVmPaginatedSearchResponseToJSON(value.permissions),
        'roles': value.roles === undefined ? undefined : (value.roles === null ? null : (value.roles as Array<any>).map(RoleListVmToJSON)),
        'relations': value.relations === undefined ? undefined : (value.relations === null ? null : (value.relations as Array<any>).map(RolePermissionDtoToJSON)),
    };
}


